import router from '../../router'
import qs from 'qs'
import axios from 'axios'
import {Loading, Message} from 'element-ui'
import merge from 'lodash/merge'
import store from '../../store'

let loadingInstance

function loading () {
  loadingInstance = Loading.service({
    fullscreen: true,
    text: '数据获取中,请稍后...',
    customClass: 'agile-loading'
  })
}

function unloading () {
  loadingInstance && loadingInstance.close()
}

const http = axios.create({
  timeout: 1000 * 60,
  withCredentials: true,
  headers: {
    // 'Content-Type': 'application/json;charset=utf-8',
    'Content-Type': 'application/x-www-form-urlencoded',
    'ClientFlag': 'ty-http-js-client'
  }
})

http.interceptors.request.use(
  (request) => {
    // console.log('request queryString:', request.params)
    // console.log('request payload:', request.data)
    // console.log('request custom:', request.custom)

    if (request.custom.enableLoading) {
      loading()
    }

    request.headers['Authorization'] = store.state.user.token
    request.headers['ModuleId'] = request.custom.moduleId || ''
    return request
  },
  (error) => {
    unloading()
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (response) => {
    // console.log('response', response)
    unloading()
    if (response && response.data) {
      const code = response.data.code
      const msg = response.data.resMsg
      switch (code) {
        case 200:
          return Promise.resolve(response.data)
        case 1001:
          // Message.closeAll()
          Message.error('身份校验失败，请重新登录')
          setTimeout(() => {
            router.push('/login')
          }, 3000)
          return Promise.reject(response)
        default:
          Message.error(errorMsg(code, msg))
          return Promise.reject(response)
      }
    } else {
      Message.error('响应异常!')
      return Promise.reject(response)
    }
  },

  (err) => {
    // console.log('err', err)
    unloading()
    let errMsg
    if (err && err.response && err.response.status) {
      switch (err.response.status) {
        case 401:
          errMsg = '登录状态失效，请重新登录'
          router.push('/login')
          break
        case 403:
          errMsg = '拒绝访问'
          break
        case 408:
          errMsg = '请求超时'
          break
        case 500:
          errMsg = '服务器内部错误'
          break
        case 501:
          errMsg = '服务未实现'
          break
        case 502:
          errMsg = '网关错误'
          break
        case 503:
          errMsg = '服务不可用'
          break
        case 504:
          errMsg = '网关超时'
          break
        case 505:
          errMsg = 'HTTP版本不受支持'
          break
        default:
          errMsg = err.response.data.resMsg
          break
      }
    } else {
      errMsg = err
    }
    Message.error(errMsg)
    return Promise.reject(errMsg)
  }
)

http.wrapUrl = (url) => {
  return '/dspweb-mgt-api' + url
}

const defaultParams = {
  t: new Date().getTime()
}

http.appendDefaultParams = (params = {}, isAppend = true) => {
  return isAppend ? merge({}, defaultParams, params) : params
}

http.serializeParams = (params = {}, isAppend = true, contentType = 'json') => {
  if (params instanceof FormData) {
    return params
  }
  params = isAppend ? merge({}, defaultParams, params) : params
  return contentType === 'json' ? JSON.stringify(params) : qs.stringify(params)
}

http.headers = (headers) => {
  http.defaults.headers = merge({}, http.defaults.headers, headers)
  return http
}

http.get = (url, param = {}) => {
  let custom = extractCustom(param)
  return http({url: http.wrapUrl(url), method: 'get', params: http.appendDefaultParams(param), custom})
}

http.post = (url, data, param = {}) => {
  let custom = extractCustom(data || param)
  if (data) {
    return http({url: http.wrapUrl(url), method: 'post', data: http.serializeParams(data, true, 'qs'), custom})
  }
  return http({url: http.wrapUrl(url), method: 'post', params: http.appendDefaultParams(param), custom})
}

http.put = (url, data, param = {}) => {
  let custom = extractCustom(data || param)
  if (data) {
    return http({url: http.wrapUrl(url), method: 'put', data: http.serializeParams(data, false), custom})
  }
  return http({url: http.wrapUrl(url), method: 'put', params: http.appendDefaultParams(param), custom})
}

http.delete = (url, data = {}) => {
  let custom = extractCustom(data)
  return http({url: http.wrapUrl(url), method: 'delete', data: http.serializeParams(data, false), custom})
}

const CUSTOM_FIELD_NAME = '__ext__'

http.custom = (params = {}, ext) => {
  let custom = {}
  custom[CUSTOM_FIELD_NAME] = ext
  return merge(params || {}, custom)
}

function extractCustom (params) {
  params = params || {}
  let custom = params[CUSTOM_FIELD_NAME]
  delete params[CUSTOM_FIELD_NAME]
  return custom
}

function errorMsg (code, msg) {
  switch (code) {
    case 400:
      return '参数有误'
    case 1000:
      return '操作失败，请刷新重试'
    case 1001:
      return '身份校验失败，请重新登录'
    case 1003:
      return '权限校验失败，请重新登录'
    case 1004:
      return '数据存在绑定关系'
    case 1005:
      return '旧密码有误，请重新输入'
    case 1006:
      return '退款失败：账户余额不足'
    default:
      return '未知错误，请联系系统管理员'
  }
}

export default http



// WEBPACK FOOTER //
// ./src/assets/js/http.js